






import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
    computed: {
        ...mapGetters(['getFormErrors'])
    }
})
export default class FromErrorComponent extends Vue {
    @Prop() formKey!: string;
}
